import React from "react";
import { CalendarSharerItems as SharerItems } from "./CalendarSharerItems";

export const ActionsPopup = ({
  isActive,
  setIsActive,
  print,
  downloadLink,
                               printLink,
  filteredEvents,
    helpLink,
    copyViewLink,
    copyEditLink,
    uid,
    euid
}) => {
  return (
    <div className={`filterPopup ${isActive ? "active" : ""}`}>
      <div className="filterPopup__header">
        <i className="fal fa-filter"></i>
        <h3>Acties</h3>
        <button
          className="btn filterPopup__closeBtn"
          onClick={() => setIsActive(false)}
        >
          <i className="fal fa-times"></i>
          <span className="screen-reader-text">Popup sluiten</span>
        </button>
      </div>
      <div className="filterPopup__body">
        <ul className="popupItemList">
          <li>
            <div>
              <i className="fal fa-download"></i>Abonneer
            </div>
            <a
              className="btn btn-primary text-white download-ics-trigger"
              href={downloadLink}
              target="_blank"
            >
              Abonneer
            </a>
          </li>
          {euid && (<li>
            <div>
              <i className="fal fa-copy"></i>Link beheer
            </div>
            <button
                className="btn btn-primary print-trigger"
                onClick={() => copyEditLink()}
            >
              Copy
            </button>
          </li>)}
          {uid && (
          <li>
            <div>
              <i className="fal fa-copy"></i>Link openbaar
            </div>
            <button
                className="btn btn-primary print-trigger"
                onClick={() => copyViewLink()}
            >
              Copy
            </button>
          </li>)}
          <li>
            <div>
              <i className="fal fa-print"></i>Print
            </div>
            <a
                className="btn btn-primary text-white download-ics-trigger"
                href={printLink}
                target="_blank"
            >
              Print
            </a>
          </li>
          <li>
            <div>
              <i className="fa fa-question"></i>Hulp nodig?
            </div>
            <a
                className="btn btn-primary text-white download-ics-trigger"
                href={helpLink}
                target="_self"
            >
              Hulp
            </a>
          </li>
          <li>
            <div>
              <i className="fal fa-share-alt"></i>Delen
            </div>
            <SharerItems filteredEvents={filteredEvents} />
          </li>
        </ul>
      </div>
    </div>
  );
};
